// Must come before all other side effects imports
import './angular_entrypoint';

import 'angular-ui-router';
import 'angular-smart-table';
import 'angular-klaxon';
import 'st-multi-sort';
import 'angular-resource';
import 'angular-xeditable/dist/js/xeditable';
import 'angular-ui-bootstrap';
import 'ngToast';
import 'font-awesome-webpack-4';

import './style.styl';

import foodhubs from 'goodeggs-foodhubs';
import catalogHelpers from 'goodeggs-purchase-orders-sdk/catalog/helpers';
import {activeDropoffWindowOptions} from 'goodeggs-purchase-orders-contracts/enum';

// This module requires google authentication.
angular
  .module('internal', [
    // vendor modules
    'ui.router',
    'xeditable',
    'ui.bootstrap',
    'ngAnimate',
    'ngSanitize',
    'ngToast',
    // make sure this comes before 'goodeggs-employee-roles/lib/angular/require_permission' module
    require('goodeggs-authentication-tokens/lib/angular/require_auth')('opsEmployeesApi'),
    require('goodeggs-employee-roles/lib/angular'),
    require('goodeggs-employee-roles/lib/angular/require_permission'),

    // local modules
    require('goodeggs-ops-angular-modules/offline_alert'),
    require('goodeggs-ops-angular-modules/config/ui_router'),
    require('goodeggs-ops-angular-modules/services/rollbar').name,

    require('local_modules/services/toaster').default,
    require('local_modules/services/promise').default,

    require('local_modules/modals/confirm_action_modal').default,

    // states
    require('./purchase_orders').default,
    require('./catalog').default,
    require('./procurement_schedules').default,

    require('goodeggs-purchase-orders-sdk/procurement_schedule/angular_resource'),
  ])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('foodhub', {
        url: '/:foodhubSlug',
        abstract: true,
        controller: require('./controller').default,
        template: require('./template'),
        resolve: {
          foodhub: ngInject(($stateParams) => {
            const foodhub = foodhubs.bySlug($stateParams.foodhubSlug);
            if (!foodhub?.isActive) {
              throw new Error(`Inactive foodhub: ${$stateParams.foodhubSlug}`);
            }
            console.log('BUB', foodhub.slug);
            return foodhub;
          }),
        },
      }),
    ),
  );

angular
  .module('app', [require('./public').default, 'internal'])

  .constant('settings', window.settings)
  .constant('shouldMigrateToRiversand', catalogHelpers.shouldMigrateToRiversand)
  .constant('getCatalogProductStructureType', catalogHelpers.getCatalogProductStructureType)
  .constant('activeDropoffWindowOptions', activeDropoffWindowOptions)
  .config((ngToastProvider) =>
    ngToastProvider.configure({
      animation: 'fade',
      timeout: 4000,
      dismissOnTimeout: false,
      verticalPosition: 'bottom',
      horizontalPosition: 'left',
      dismissButton: true,
    }),
  )
  .run(
    (editableOptions) =>
      // xeditable configuration -- use Bootstrap 3
      (editableOptions.theme = 'bs3'),
  );
